const INACTIVITY_LIMIT = 15 * 60 * 1000   // 15 min
const WARNING_TIME = 14 * 60 * 1000      // warn at 14 min
const COUNTDOWN_SECONDS = 60            // 1 minute warning

let inactivityTimer = null
let warningTimer = null
let countdownTimer = null

// state
const state = {
    showWarning: false,
    countdown: COUNTDOWN_SECONDS,
    lastActivity: Date.now()
}

const getters = {}

// mutations
const mutations = {
    SET_ACTIVITY(state) {
      state.lastActivity = Date.now()
    },
    SHOW_WARNING(state) {
      state.showWarning = true
      state.countdown = COUNTDOWN_SECONDS
    },
    HIDE_WARNING(state) {
      state.showWarning = false
      state.countdown = COUNTDOWN_SECONDS
    },
    TICK_COUNTDOWN(state) {
      state.countdown--
    }
}

// actions
const actions = {

    init({ dispatch }) {
      dispatch('resetTimers')
    },

    userActivity({ state, commit, dispatch }) {
      // When warning is visible, ignore activity (e.g. mousemove) so the user
      // can click "Continue Session". Only the button triggers continueSession.
      if (state.showWarning) return

      commit('SET_ACTIVITY')
      dispatch('resetTimers')

      // Sync across tabs
      localStorage.setItem('lastActivity', Date.now())
    },

    resetTimers({ commit, dispatch }) {
      clearTimeout(inactivityTimer)
      clearTimeout(warningTimer)
      clearInterval(countdownTimer)

      commit('HIDE_WARNING')

      warningTimer = setTimeout(() => {
        commit('SHOW_WARNING')
        dispatch('startCountdown')
      }, WARNING_TIME)

      inactivityTimer = setTimeout(() => {
        dispatch('expireSession')
      }, INACTIVITY_LIMIT)
    },

    startCountdown({ state, commit, dispatch }) {
      clearInterval(countdownTimer)

      countdownTimer = setInterval(() => {
        if (state.countdown <= 1) {
          clearInterval(countdownTimer)
          dispatch('expireSession')
        } else {
          commit('TICK_COUNTDOWN')
        }
      }, 1000)
    },

    continueSession({ commit, dispatch }) {
      // Explicitly reset timers and hide warning (don't rely on userActivity,
      // which is no-op while warning is showing).
      commit('SET_ACTIVITY')
      dispatch('resetTimers')
      localStorage.setItem('lastActivity', Date.now())
    },

    expireSession({ commit, dispatch }) {
      clearInterval(countdownTimer)
      commit('HIDE_WARNING')

      sessionStorage.setItem(
        'logoutReason',
        'You were logged out due to inactivity.'
      )

      dispatch('auth/logout', null, { root: true })
    },

    stop() {
      clearTimeout(inactivityTimer)
      clearTimeout(warningTimer)
      clearInterval(countdownTimer)
    }
}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}